import type { FieldValues, UseFormGetValues } from 'react-hook-form';
import type { UploadFnReturn } from '@/hooks/useFileUpload';
import type { SignedApplicationAssetResponse } from '@/types/Shared';
import type { FacadeImprovementAttachment } from '../../types';

export const convertFulfilledFileUploadToAttachment = (
  res: PromiseSettledResult<UploadFnReturn<File, any>>[],
  getValues: UseFormGetValues<FieldValues>
) => {
  return res.reduce<Record<string, FacadeImprovementAttachment>>((acc, result) => {
    if (result.status === 'rejected') return acc;

    const { files, sign, field } = result.value;

    if (!field) throw Error("field key doesn't exist");

    let signRes: SignedApplicationAssetResponse[] = [];

    if (Array.isArray(sign)) {
      signRes = [...sign];
    } else {
      signRes = [{ ...sign }];
    }

    const newAttachment = {
      ...getValues('step5')[field.key],
      selectedFiles: signRes.map((signature, index) => ({
        name: files[index].name,
        path: signature.path,
        key: signature.key,
        type: files[index].type,
        field: field.key,
        description: field.description,
      })),
    };

    // Remove description if file exist
    if (newAttachment.selectedFiles.length > 0 && !!newAttachment.haveFilesDescription && !!newAttachment.haveFiles) {
      newAttachment.haveFiles = false;
      newAttachment.haveFilesDescription = '';
    }

    acc[field.key] = newAttachment;

    return acc;
  }, {});
};
